import upperFirst from 'lodash/upperFirst';

export function capitalizeObjectKeys<T>(obj: any): T {
  return Object.fromEntries(Object.entries(obj).map(([key, value]) => [upperFirst(key), value])) as T;
}
